import React from "react";
import circleText1 from "../assets/icons/circleText1.svg";
import MuhammadJindan from "../assets/icons/Muhammadjindan.svg";
import CVFile from "../assets/CV - Muhammad Jindan.pdf";

const Header = () => {
  const handleDownload = () => {
    // Membuat link untuk file CV yang akan didownload
    const downloadLink = document.createElement("a");
    downloadLink.href = CVFile;
    downloadLink.download = "MuhammadJindanCV.pdf";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // const docGoogleCV = "https://docs.google.com/document/d/1mOhj_h2pG0s9FSLv7Bn2nOUXqsT5KM-xcoNeemiCC98/edit?usp=sharing"

  return (
    <div className="min-h-screen flex justify-center items-center" id="header">
      <div className="min-w-full">
        <div className="flex justify-between items-center">
          <div className="cursor-default">
            <h1 className="text-3xl md:text-8xl font-extrabold">HELLO THERE</h1>
            <h2 className="text-2xl md:text-8xl font-black italic text-[#FF6812] tracking-tighter">
              <span className="text-base md:text-5xl font-bold text-[#FEFEFE]">I'M</span>{" "}
              MUH. JINDAN
            </h2>
          </div>
          <div className="transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
            <a href="https://www.linkedin.com/in/muhammad-jindan/" target="_blank">
              <img
                src={circleText1}
                alt="circleText1"
                className="animate-[spin_5s_ease-in-out_infinite] w-20 md:w-fit"
              />
            </a>
          </div>
        </div>
        <div className="flex justify-between mt-4 md:mt-12 items-center">
          <div>
            <button
              className="bg-white text-black font-black whitespace-nowrap md:text-3xl px-6 md:px-14 py-1 md:py-4 rounded-full transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer"
              onClick={handleDownload}
            >
              Curriculum Vitae
            </button>
            {/* <a
              className="bg-white text-black font-black whitespace-nowrap md:text-3xl px-6 md:px-14 py-1 md:py-4 rounded-full transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer"
              href={docGoogleCV}
              target="_blank"
              rel="noopener noreferrer"
            >
              Curriculum Vitae
            </a> */}
            <img src={MuhammadJindan} className="mt-4 md:mt-10 w-20 md:w-fit" />
          </div>
          <div className="flex flex-col cursor-default">
            <h1 className="text-xl md:text-8xl text-right font-extrabold">
              <span className="text-xs md:text-5xl font-bold italic">A </span>SOFTWARE
            </h1>
            <h1 className="md:text-7xl font-extrabold text-right italic">ENGINEER</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
